export const POLICY_GROUPS = [
  {
    label: 'User Types',
    policies: [
      { id: 'authenticated_user', label: 'Any User' },
      { id: 'advisors', label: 'Advisors' },
      { id: 'wealthOwners', label: 'Wealth Owners' }
    ]
  },
  {
    label: 'Access Levels',
    policies: [
      { id: 'allAccounts', label: 'All Accounts' },
      { id: 'denali_admin', label: 'Denali Admin' },
      { id: 'admin_denali_catalog', label: 'Catalog Admin' },
      { id: 'denali_ai_enabled', label: 'AI Enabled' }
    ]
  },
  {
    label: 'Internal',
    policies: [
      { id: 'danger_zone', label: 'Danger Zone' },
      { id: 'admin_denali_internal', label: 'Denali Internal' },
      { id: 'denali_labs', label: 'Denali Labs' },
      { id: 'internalOnly', label: 'Internal Only' }
    ]
  }
]

export const CURATED_POLICY_IDS = new Set(
  POLICY_GROUPS.flatMap(g => g.policies.map(p => p.id))
)

const POLICY_LABEL_MAP = Object.fromEntries(
  POLICY_GROUPS.flatMap(g => g.policies.map(p => [p.id, p.label]))
)

export function policyLabel (policyId) {
  return POLICY_LABEL_MAP[policyId] || policyId
}
